import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { cn } from '@air/utils-tailwind';

export const MainContent = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'main'>>(
  ({ className, ...restOfProps }: ComponentPropsWithoutRef<'main'>, forwardedRef) => (
    <main
      ref={forwardedRef}
      className={cn('relative flex h-[inherit] flex-1 flex-col overflow-y-auto', className)}
      {...restOfProps}
    />
  ),
);

MainContent.displayName = 'Main';
